import './sass/style.scss';
import BurgerMenu from './scripts/BurgerMenu';
import Lang from './scripts/Lang';
import GiftCertificates from './scripts/GiftCertificates/GiftCertificates';

const burgerMenu = new BurgerMenu();
burgerMenu.run();
new Lang();
new GiftCertificates();
